// import React, { useEffect, useMemo, useState } from "react";
// import {
//   Table,
//   Button,
//   Form,
//   Modal,
//   InputGroup,
//   Pagination,
//   Badge,
//   Spinner,
// } from "react-bootstrap";
// import api from "../../api";
// import Can from "../../components/Can";
// import { usePermissions } from "../../context/PermissionContext";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import "./DesignationManagementPage.css";
// import { getSerialNumber } from "../../utils/pagination";
// import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
// import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

// const initialForm = {
//   name: "",
//   code: "",
//   description: "",
//   department_id: "",
//   level: "",
//   display_order: "",
//   is_managerial: false,
// };

// export default function DesignationManagementPage() {
//   const { can } = usePermissions();

//   const [designations, setDesignations] = useState([]);
//   const [total, setTotal] = useState(0);
//   const [departments, setDepartments] = useState([]);

//   const [search, setSearch] = useState("");
//   const [departmentFilter, setDepartmentFilter] = useState("");
//   const [managerialFilter, setManagerialFilter] = useState(""); // "" | "1" | "0"
//   const [statusFilter, setStatusFilter] = useState(""); // "" | "1" | "0"

//   const [sortField, setSortField] = useState("display_order");
//   const [sortOrder, setSortOrder] = useState("asc");

//   const [currentPage, setCurrentPage] = useState(1);
//   const [pageSize, setPageSize] = useState(10);

//   const [loading, setLoading] = useState(false);
//   const [saving, setSaving] = useState(false);

//   const [form, setForm] = useState(initialForm);
//   const [editId, setEditId] = useState(null);
//   const [showModal, setShowModal] = useState(false);

//   const [deleteTarget, setDeleteTarget] = useState(null);
//   const [showDeleteModal, setShowDeleteModal] = useState(false);

//   useEffect(() => {
//     fetchDepartments();
//   }, []);

//   useEffect(() => {
//     fetchDesignations();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [search, departmentFilter, managerialFilter, statusFilter, sortField, sortOrder, currentPage, pageSize]);

//   const fetchDepartments = async () => {
//     try {
//       const res = await api.get("/departments", { params: { is_active: 1, pageSize: 200 } });
//       setDepartments(Array.isArray(res.data?.data) ? res.data.data : []);
//     } catch (err) {
//       console.error("Fetch departments error:", err);
//     }
//   };

//   const fetchDesignations = async () => {
//     try {
//       setLoading(true);
//       const res = await api.get("/designations", {
//         params: {
//           search: search || undefined,
//           department_id: departmentFilter || undefined,
//           is_managerial: managerialFilter === "" ? undefined : managerialFilter,
//           is_active: statusFilter === "" ? undefined : statusFilter,
//           sortField,
//           sortOrder,
//           page: currentPage,
//           pageSize,
//         },
//       });
//       setDesignations(Array.isArray(res.data?.data) ? res.data.data : []);
//       setTotal(res.data?.meta?.total || 0);
//     } catch (err) {
//       console.error("Fetch designations error:", err);
//       toast.error(err.response?.data?.message || "Failed to fetch designations");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const departmentMap = useMemo(
//     () => Object.fromEntries(departments.map((d) => [String(d.id), d.name])),
//     [departments]
//   );

//   const totalPages = Math.max(Math.ceil(total / pageSize), 1);

//   const handleSort = (field) => {
//     if (sortField === field) {
//       setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
//     } else {
//       setSortField(field);
//       setSortOrder("asc");
//     }
//   };

//   const sortIcon = (field) => (sortField !== field ? "↕" : sortOrder === "asc" ? "↑" : "↓");

//   const handleChange = (field, value) => setForm((prev) => ({ ...prev, [field]: value }));

//   const openAdd = () => {
//     setForm(initialForm);
//     setEditId(null);
//     setShowModal(true);
//   };

//   const openEdit = (des) => {
//     setForm({
//       name: des.name || "",
//       code: des.code || "",
//       description: des.description || "",
//       department_id: des.department_id || "",
//       level: des.level ?? "",
//       display_order: des.display_order ?? "",
//       is_managerial: !!des.is_managerial,
//     });
//     setEditId(des.id);
//     setShowModal(true);
//   };

//   const closeModal = () => {
//     setShowModal(false);
//     setEditId(null);
//     setForm(initialForm);
//   };

//   const handleSave = async () => {
//     if (!form.name.trim()) {
//       toast.warning("Designation name is required");
//       return;
//     }

//     const payload = {
//       name: form.name.trim(),
//       code: form.code.trim() || undefined,
//       description: form.description.trim() || null,
//       department_id: form.department_id || null,
//       level: form.level === "" ? null : Number(form.level),
//       display_order: form.display_order === "" ? 0 : Number(form.display_order),
//       is_managerial: !!form.is_managerial,
//     };

//     try {
//       setSaving(true);
//       if (editId) {
//         await api.put(`/designations/${editId}`, payload);
//         toast.success("Designation updated");
//       } else {
//         await api.post("/designations", payload);
//         toast.success("Designation created");
//       }
//       closeModal();
//       fetchDesignations();
//     } catch (err) {
//       console.error("Save designation error:", err);
//       toast.error(err.response?.data?.message || "Failed to save designation");
//     } finally {
//       setSaving(false);
//     }
//   };

//   const toggleStatus = async (des) => {
//     try {
//       await api.patch(`/designations/${des.id}/status`, { is_active: !des.is_active });
//       toast.success(des.is_active ? "Designation deactivated" : "Designation activated");
//       fetchDesignations();
//     } catch (err) {
//       console.error("Toggle status error:", err);
//       toast.error(err.response?.data?.message || "Failed to update status");
//     }
//   };

//   const openDeleteModal = (des) => {
//     setDeleteTarget(des);
//     setShowDeleteModal(true);
//   };

//   const closeDeleteModal = () => {
//     setDeleteTarget(null);
//     setShowDeleteModal(false);
//   };

//   const confirmDelete = async () => {
//     if (!deleteTarget) return;
//     try {
//       await api.delete(`/designations/${deleteTarget.id}`);
//       toast.success("Designation deleted");
//       closeDeleteModal();
//       fetchDesignations();
//     } catch (err) {
//       console.error("Delete designation error:", err);
//       const data = err.response?.data;
//       if (data?.code === "DESIGNATION_IN_USE") {
//         toast.error(`Cannot delete: ${data.details?.users || 0} user(s) still use this designation. Deactivate instead or reassign them first.`);
//       } else {
//         toast.error(data?.message || "Failed to delete designation");
//       }
//       closeDeleteModal();
//     }
//   };

//   return (
//     <div className="unit-page desig-mgmt-theme">
//       <ToastContainer position="top-right" autoClose={3000} />

//       <div className="unit-header">
//         <div>
//           <div className="unit-page-label">Configuration</div>
//           <h2>Designation Management</h2>
//           <p>Manage job titles (designations) — configurable, not authorization roles.</p>
//         </div>

//         <div className="unit-header-actions">
//           <Button className="unit-btn unit-btn-light" onClick={fetchDesignations}>
//             <i className="fa-solid fa-rotate" aria-hidden="true"></i>
//             Refresh
//           </Button>

//           <Can moduleKey="designations" actionKey="create">
//             <Button className="unit-btn unit-btn-primary" onClick={openAdd}>
//               <i className="fa-solid fa-plus" aria-hidden="true"></i>
//               Add Designation
//             </Button>
//           </Can>
//         </div>
//       </div>

//       <div className="unit-stats-row">
//         <div className="unit-stat-card">
//           <div className="desig-stat-icon desig-stat-icon-primary">
//             <i className="fa-solid fa-briefcase" aria-hidden="true"></i>
//           </div>
//           <div className="desig-stat-text">
//             <span>Total Designations</span>
//             <strong>{total}</strong>
//           </div>
//         </div>
//         <div className="unit-stat-card">
//           <div className="desig-stat-icon desig-stat-icon-accent">
//             <i className="fa-solid fa-file-lines" aria-hidden="true"></i>
//           </div>
//           <div className="desig-stat-text">
//             <span>Current Page</span>
//             <strong>{currentPage}</strong>
//           </div>
//         </div>
//       </div>

//       <div className="unit-card">
//         <div className="unit-toolbar">
//           <div>
//             <h5>
//               <i className="fa-solid fa-id-badge desig-list-icon" aria-hidden="true"></i>
//               Designation List
//             </h5>
//             <p>Search, filter, add, update, activate/deactivate or delete designations.</p>
//           </div>

//           <div className="unit-toolbar-actions desig-filters-row">
//             <InputGroup className="unit-search desig-search">
//               <InputGroup.Text aria-hidden="true">
//                 <i className="fa-solid fa-magnifying-glass"></i>
//               </InputGroup.Text>
//               <Form.Control
//                 placeholder="Search name or code..."
//                 aria-label="Search name or code"
//                 value={search}
//                 onChange={(e) => {
//                   setCurrentPage(1);
//                   setSearch(e.target.value);
//                 }}
//               />
//             </InputGroup>

//             <div className="desig-select-wrap">
//               <i className="fa-solid fa-building desig-select-icon" aria-hidden="true"></i>
//               <Form.Select
//                 className="desig-filter-select"
//                 aria-label="Filter by department"
//                 value={departmentFilter}
//                 onChange={(e) => {
//                   setCurrentPage(1);
//                   setDepartmentFilter(e.target.value);
//                 }}
//               >
//                 <option value="">All Departments</option>
//                 {departments.map((d) => (
//                   <option key={d.id} value={d.id}>
//                     {d.name}
//                   </option>
//                 ))}
//               </Form.Select>
//             </div>

//             <div className="desig-select-wrap">
//               <i className="fa-solid fa-user-tie desig-select-icon" aria-hidden="true"></i>
//               <Form.Select
//                 className="desig-filter-select"
//                 aria-label="Filter by managerial status"
//                 value={managerialFilter}
//                 onChange={(e) => {
//                   setCurrentPage(1);
//                   setManagerialFilter(e.target.value);
//                 }}
//               >
//                 <option value="">Managerial: Any</option>
//                 <option value="1">Managerial only</option>
//                 <option value="0">Non-managerial only</option>
//               </Form.Select>
//             </div>

//             <div className="desig-select-wrap">
//               <i className="fa-solid fa-circle-check desig-select-icon" aria-hidden="true"></i>
//               <Form.Select
//                 className="desig-filter-select"
//                 aria-label="Filter by status"
//                 value={statusFilter}
//                 onChange={(e) => {
//                   setCurrentPage(1);
//                   setStatusFilter(e.target.value);
//                 }}
//               >
//                 <option value="">All Statuses</option>
//                 <option value="1">Active</option>
//                 <option value="0">Inactive</option>
//               </Form.Select>
//             </div>

//             <Form.Select
//               className="unit-page-size"
//               aria-label="Rows per page"
//               value={pageSize}
//               onChange={(e) => {
//                 setCurrentPage(1);
//                 setPageSize(Number(e.target.value));
//               }}
//             >
//               <option value={10}>10 rows</option>
//               <option value={20}>20 rows</option>
//               <option value={50}>50 rows</option>
//             </Form.Select>
//           </div>
//         </div>

//         <div className="unit-table-wrapper">
//           {loading ? (
//             <div className="unit-loader">
//               <Spinner animation="border" />
//               <p>Loading designations...</p>
//             </div>
//           ) : (
//             <Table responsive className="unit-table">
//               <thead>
//                 <tr>
//                   <th style={{ width: 70 }}>S.NO.</th>
//                   <th className="sortable" onClick={() => handleSort("name")}>
//                     Name {sortIcon("name")}
//                   </th>
//                   <th className="sortable" onClick={() => handleSort("code")}>
//                     Code {sortIcon("code")}
//                   </th>
//                   <th>Department</th>
//                   <th className="sortable" onClick={() => handleSort("level")}>
//                     Level {sortIcon("level")}
//                   </th>
//                   <th>Managerial</th>
//                   <th className="sortable" onClick={() => handleSort("is_active")}>
//                     Status {sortIcon("is_active")}
//                   </th>
//                   <th className="text-end">Actions</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {designations.length > 0 ? (
//                   designations.map((des, index) => (
//                     <tr key={des.id}>
//                       <td>{getSerialNumber(index, currentPage, pageSize)}</td>
//                       <td>
//                         <strong>{des.name}</strong>
//                       </td>
//                       <td>{des.code}</td>
//                       <td>{des.department_name || departmentMap[String(des.department_id)] || <span className="desig-muted">—</span>}</td>
//                       <td>{des.level ?? <span className="desig-muted">—</span>}</td>
//                       <td>{des.is_managerial ? <Badge bg="info">Managerial</Badge> : <span className="desig-muted">—</span>}</td>
//                       <td>
//                         <Badge className={`unit-status ${des.is_active ? "" : "unit-status-inactive"}`}>
//                           {des.is_active ? "Active" : "Inactive"}
//                         </Badge>
//                       </td>
//                       <td>
//                         <div className="unit-actions">
//                           <Can moduleKey="designations" actionKey="edit">
//                             <Button
//                               className="unit-icon-btn unit-edit"
//                               title="Edit"
//                               aria-label="Edit designation"
//                               onClick={() => openEdit(des)}
//                             >
//                               <i className="fa-solid fa-pen" aria-hidden="true"></i>
//                             </Button>
//                           </Can>

//                           {(can("designations", "activate") || can("designations", "deactivate")) && (
//                             <Button
//                               className="unit-icon-btn desig-toggle"
//                               title={des.is_active ? "Deactivate" : "Activate"}
//                               aria-label={des.is_active ? "Deactivate designation" : "Activate designation"}
//                               onClick={() => toggleStatus(des)}
//                             >
//                               <i className={`fa-solid ${des.is_active ? "fa-pause" : "fa-play"}`} aria-hidden="true"></i>
//                             </Button>
//                           )}

//                           <Can moduleKey="designations" actionKey="delete">
//                             <Button
//                               className="unit-icon-btn unit-delete"
//                               title="Delete"
//                               aria-label="Delete designation"
//                               onClick={() => openDeleteModal(des)}
//                             >
//                               <i className="fa-solid fa-trash" aria-hidden="true"></i>
//                             </Button>
//                           </Can>
//                         </div>
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="8">
//                       <div className="unit-empty">
//                         <div className="unit-empty-icon">
//                           <i className="fa-solid fa-id-badge" aria-hidden="true"></i>
//                         </div>
//                         <h5>No designations found</h5>
//                         <p>Try another search or add a new designation.</p>
//                       </div>
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </Table>
//           )}
//         </div>

//         <div className="unit-footer">
//           <div className="unit-count-text">
//             Showing <strong>{designations.length}</strong> of <strong>{total}</strong> designations
//           </div>

//           {totalPages > 1 && (
//             <Pagination className="unit-pagination">
//               <Pagination.Prev
//                 disabled={currentPage === 1}
//                 onClick={() => setCurrentPage((p) => p - 1)}
//               />
//               {[...Array(totalPages)].map((_, i) => (
//                 <Pagination.Item
//                   key={i + 1}
//                   active={i + 1 === currentPage}
//                   onClick={() => setCurrentPage(i + 1)}
//                 >
//                   {i + 1}
//                 </Pagination.Item>
//               ))}
//               <Pagination.Next
//                 disabled={currentPage === totalPages}
//                 onClick={() => setCurrentPage((p) => p + 1)}
//               />
//             </Pagination>
//           )}
//         </div>
//       </div>

//       <Modal
//         show={showModal}
//         onHide={closeModal}
//         centered
//         className="unit-modal"
//         dialogClassName="admin-teal-modal"
//         backdropClassName="admin-teal-backdrop"
//       >
//         <Modal.Header closeButton closeLabel="Close">
//           <div className="d-flex align-items-center">
//             <BadgeOutlinedIcon className="modal-header-icon" aria-hidden="true" />
//             <Modal.Title>{editId ? "Edit Designation" : "Add New Designation"}</Modal.Title>
//           </div>
//         </Modal.Header>

//         <Modal.Body>
//           <div className="row g-3">
//             <div className="col-md-6">
//               <Form.Label>Name</Form.Label>
//               <Form.Control
//                 placeholder="e.g. Senior Software Engineer"
//                 value={form.name}
//                 onChange={(e) => handleChange("name", e.target.value)}
//               />
//             </div>

//             <div className="col-md-6">
//               <Form.Label>Code (optional — derived from name if blank)</Form.Label>
//               <Form.Control
//                 placeholder="e.g. SR_SW_ENGINEER"
//                 value={form.code}
//                 onChange={(e) => handleChange("code", e.target.value)}
//               />
//             </div>

//             <div className="col-md-12">
//               <Form.Label>Description</Form.Label>
//               <Form.Control
//                 as="textarea"
//                 rows={2}
//                 value={form.description}
//                 onChange={(e) => handleChange("description", e.target.value)}
//               />
//             </div>

//             <div className="col-md-4">
//               <Form.Label>Department (optional)</Form.Label>
//               <Form.Select
//                 value={form.department_id}
//                 onChange={(e) => handleChange("department_id", e.target.value)}
//               >
//                 <option value="">Department-agnostic</option>
//                 {departments.map((d) => (
//                   <option key={d.id} value={d.id}>
//                     {d.name}
//                   </option>
//                 ))}
//               </Form.Select>
//             </div>

//             <div className="col-md-4">
//               <Form.Label>Level (hierarchy display only)</Form.Label>
//               <Form.Control
//                 type="number"
//                 min="0"
//                 placeholder="e.g. 3"
//                 value={form.level}
//                 onChange={(e) => handleChange("level", e.target.value)}
//               />
//             </div>

//             <div className="col-md-4">
//               <Form.Label>Display Order</Form.Label>
//               <Form.Control
//                 type="number"
//                 value={form.display_order}
//                 onChange={(e) => handleChange("display_order", e.target.value)}
//               />
//             </div>

//             <div className="col-md-12">
//               <Form.Check
//                 type="checkbox"
//                 label="This designation is managerial (descriptive only — grants no permission)"
//                 checked={form.is_managerial}
//                 onChange={(e) => handleChange("is_managerial", e.target.checked)}
//               />
//             </div>
//           </div>
//         </Modal.Body>

//         <Modal.Footer>
//           <Button className="unit-btn unit-btn-light" onClick={closeModal}>
//             Cancel
//           </Button>
//           <Button className="unit-btn unit-btn-primary" onClick={handleSave} disabled={saving}>
//             {saving ? "Saving..." : editId ? "Update Designation" : "Create Designation"}
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       <Modal
//         show={showDeleteModal}
//         onHide={closeDeleteModal}
//         centered
//         className="unit-modal"
//         dialogClassName="admin-teal-modal admin-teal-modal-sm admin-teal-modal-danger"
//         backdropClassName="admin-teal-backdrop"
//       >
//         <Modal.Header closeButton closeLabel="Close">
//           <Modal.Title>Delete Designation?</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="admin-modal-danger-icon" aria-hidden="true">
//             <DeleteOutlineIcon fontSize="inherit" />
//           </div>
//           <p className="unit-delete-text text-center">
//             Are you sure you want to delete "{deleteTarget?.name}"? This action cannot be undone.
//             If active users still reference it, deletion will be blocked.
//           </p>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button className="unit-btn unit-btn-light" onClick={closeDeleteModal}>
//             Cancel
//           </Button>
//           <Button className="unit-btn unit-btn-danger" onClick={confirmDelete}>
//             Delete
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// }





import React, { useEffect, useMemo, useState } from "react";
import { compactPageItems } from "../../components/ui/compactPagination";
import {
  Table,
  Button,
  Form,
  Modal,
  InputGroup,
  Pagination,
  Badge,
  Spinner,
} from "react-bootstrap";
import api from "../../api";
import Can from "../../components/Can";
import { usePermissions } from "../../context/PermissionContext";
import { toast } from "react-toastify";
import "../../theme/adminIconField.css";
import "./DesignationManagementPage.css";
import { getSerialNumber } from "../../utils/pagination";

const initialForm = {
  name: "",
  code: "",
  description: "",
  department_id: "",
  level: "",
  display_order: "",
  is_managerial: false,
};

export default function DesignationManagementPage() {
  const { can } = usePermissions();

  const [designations, setDesignations] = useState([]);
  const [total, setTotal] = useState(0);
  const [departments, setDepartments] = useState([]);

  const [search, setSearch] = useState("");
  const [departmentFilter, setDepartmentFilter] = useState("");
  const [managerialFilter, setManagerialFilter] = useState(""); // "" | "1" | "0"
  const [statusFilter, setStatusFilter] = useState(""); // "" | "1" | "0"

  const [sortField, setSortField] = useState("display_order");
  const [sortOrder, setSortOrder] = useState("asc");

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const [form, setForm] = useState(initialForm);
  const [editId, setEditId] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const [deleteTarget, setDeleteTarget] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  useEffect(() => {
    fetchDepartments();
  }, []);

  useEffect(() => {
    fetchDesignations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, departmentFilter, managerialFilter, statusFilter, sortField, sortOrder, currentPage, pageSize]);

  const fetchDepartments = async () => {
    try {
      const res = await api.get("/departments", { params: { is_active: 1, pageSize: 200 } });
      setDepartments(Array.isArray(res.data?.data) ? res.data.data : []);
    } catch (err) {
      console.error("Fetch departments error:", err);
    }
  };

  const fetchDesignations = async () => {
    try {
      setLoading(true);
      const res = await api.get("/designations", {
        params: {
          search: search || undefined,
          department_id: departmentFilter || undefined,
          is_managerial: managerialFilter === "" ? undefined : managerialFilter,
          is_active: statusFilter === "" ? undefined : statusFilter,
          sortField,
          sortOrder,
          page: currentPage,
          pageSize,
        },
      });
      setDesignations(Array.isArray(res.data?.data) ? res.data.data : []);
      setTotal(res.data?.meta?.total || 0);
    } catch (err) {
      console.error("Fetch designations error:", err);
      toast.error(err.response?.data?.message || "Failed to fetch designations");
    } finally {
      setLoading(false);
    }
  };

  const departmentMap = useMemo(
    () => Object.fromEntries(departments.map((d) => [String(d.id), d.name])),
    [departments]
  );

  const totalPages = Math.max(Math.ceil(total / pageSize), 1);

  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
  };

  const sortIcon = (field) => (sortField !== field ? "↕" : sortOrder === "asc" ? "↑" : "↓");

  const handleChange = (field, value) => setForm((prev) => ({ ...prev, [field]: value }));

  const openAdd = () => {
    setForm(initialForm);
    setEditId(null);
    setShowModal(true);
  };

  const openEdit = (des) => {
    setForm({
      name: des.name || "",
      code: des.code || "",
      description: des.description || "",
      department_id: des.department_id || "",
      level: des.level ?? "",
      display_order: des.display_order ?? "",
      is_managerial: !!des.is_managerial,
    });
    setEditId(des.id);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setEditId(null);
    setForm(initialForm);
  };

  const handleSave = async () => {
    if (!form.name.trim()) {
      toast.warning("Designation name is required");
      return;
    }

    const payload = {
      name: form.name.trim(),
      code: form.code.trim() || undefined,
      description: form.description.trim() || null,
      department_id: form.department_id || null,
      level: form.level === "" ? null : Number(form.level),
      display_order: form.display_order === "" ? 0 : Number(form.display_order),
      is_managerial: !!form.is_managerial,
    };

    try {
      setSaving(true);
      if (editId) {
        await api.put(`/designations/${editId}`, payload);
        toast.success("Designation updated");
      } else {
        await api.post("/designations", payload);
        toast.success("Designation created");
      }
      closeModal();
      fetchDesignations();
    } catch (err) {
      console.error("Save designation error:", err);
      toast.error(err.response?.data?.message || "Failed to save designation");
    } finally {
      setSaving(false);
    }
  };

  const toggleStatus = async (des) => {
    try {
      await api.patch(`/designations/${des.id}/status`, { is_active: !des.is_active });
      toast.success(des.is_active ? "Designation deactivated" : "Designation activated");
      fetchDesignations();
    } catch (err) {
      console.error("Toggle status error:", err);
      toast.error(err.response?.data?.message || "Failed to update status");
    }
  };

  const openDeleteModal = (des) => {
    setDeleteTarget(des);
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setDeleteTarget(null);
    setShowDeleteModal(false);
  };

  const confirmDelete = async () => {
    if (!deleteTarget) return;
    try {
      await api.delete(`/designations/${deleteTarget.id}`);
      toast.success("Designation deleted");
      closeDeleteModal();
      fetchDesignations();
    } catch (err) {
      console.error("Delete designation error:", err);
      const data = err.response?.data;
      if (data?.code === "DESIGNATION_IN_USE") {
        toast.error(`Cannot delete: ${data.details?.users || 0} user(s) still use this designation. Deactivate instead or reassign them first.`);
      } else {
        toast.error(data?.message || "Failed to delete designation");
      }
      closeDeleteModal();
    }
  };

  return (
    <div className="unit-page desig-mgmt-theme">

      <div className="designation-heading-box">
        <div className="designation-heading-content">
          <div className="designation-heading-icon">
            <i className="fa-solid fa-id-badge" aria-hidden="true"></i>
          </div>

          <div>
            <div className="unit-page-label">Configuration</div>
            <h2>Designation Management</h2>
            <p>Manage job titles (designations) — configurable, not authorization roles.</p>
          </div>
        </div>

        <div className="unit-header-actions">
          <Button className="unit-btn unit-btn-light" onClick={fetchDesignations}>
            <i className="fa-solid fa-rotate" aria-hidden="true"></i>
            Refresh
          </Button>

          <Can moduleKey="designations" actionKey="create">
            <Button className="unit-btn unit-btn-primary" onClick={openAdd}>
              <i className="fa-solid fa-plus" aria-hidden="true"></i>
              Add Designation
            </Button>
          </Can>
        </div>
      </div>

      <div className="unit-stats-row">
        <div className="unit-stat-card designation-stat-blue">
          <div className="designation-stat-content">
            <div className="desig-stat-text">
              <span>Total Designations</span>
              <strong>{total}</strong>
            </div>

            <div className="desig-stat-icon">
              <i className="fa-solid fa-briefcase" aria-hidden="true"></i>
            </div>
          </div>
        </div>

        <div className="unit-stat-card designation-stat-purple">
          <div className="designation-stat-content">
            <div className="desig-stat-text">
              <span>Current Page</span>
              <strong>{currentPage}</strong>
            </div>

            <div className="desig-stat-icon">
              <i className="fa-solid fa-file-lines" aria-hidden="true"></i>
            </div>
          </div>
        </div>

        <div className="unit-stat-card designation-stat-green">
          <div className="designation-stat-content">
            <div className="desig-stat-text">
              <span>Rows Per Page</span>
              <strong>{pageSize}</strong>
            </div>

            <div className="desig-stat-icon">
              <i className="fa-solid fa-table-list" aria-hidden="true"></i>
            </div>
          </div>
        </div>
      </div>

      <div className="unit-card">
        <div className="unit-toolbar">
          <div className="designation-section-title">
            <div className="designation-section-icon">
              <i className="fa-solid fa-table-list" aria-hidden="true"></i>
            </div>

            <div>
              <h5>Designation List</h5>
              <p>Search, filter, add, update, activate/deactivate or delete designations.</p>
            </div>
          </div>

          <div className="unit-toolbar-actions desig-filters-row">
            <InputGroup className="unit-search desig-search">
              <InputGroup.Text aria-hidden="true">
                <i className="fa-solid fa-magnifying-glass"></i>
              </InputGroup.Text>
              <Form.Control
                placeholder="Search name or code..."
                aria-label="Search name or code"
                value={search}
                onChange={(e) => {
                  setCurrentPage(1);
                  setSearch(e.target.value);
                }}
              />

              {search && (
                <Button
                  className="unit-clear-btn"
                  onClick={() => {
                    setCurrentPage(1);
                    setSearch("");
                  }}
                  title="Clear search"
                  aria-label="Clear search"
                >
                  <i className="fa-solid fa-xmark" aria-hidden="true"></i>
                </Button>
              )}
            </InputGroup>

            <div className="desig-select-wrap">
              <i className="fa-solid fa-building desig-select-icon" aria-hidden="true"></i>
              <Form.Select
                className="desig-filter-select"
                aria-label="Filter by department"
                value={departmentFilter}
                onChange={(e) => {
                  setCurrentPage(1);
                  setDepartmentFilter(e.target.value);
                }}
              >
                <option value="">All Departments</option>
                {departments.map((d) => (
                  <option key={d.id} value={d.id}>
                    {d.name}
                  </option>
                ))}
              </Form.Select>
            </div>

            <div className="desig-select-wrap">
              <i className="fa-solid fa-user-tie desig-select-icon" aria-hidden="true"></i>
              <Form.Select
                className="desig-filter-select"
                aria-label="Filter by managerial status"
                value={managerialFilter}
                onChange={(e) => {
                  setCurrentPage(1);
                  setManagerialFilter(e.target.value);
                }}
              >
                <option value="">Managerial: Any</option>
                <option value="1">Managerial only</option>
                <option value="0">Non-managerial only</option>
              </Form.Select>
            </div>

            <div className="desig-select-wrap">
              <i className="fa-solid fa-circle-check desig-select-icon" aria-hidden="true"></i>
              <Form.Select
                className="desig-filter-select"
                aria-label="Filter by status"
                value={statusFilter}
                onChange={(e) => {
                  setCurrentPage(1);
                  setStatusFilter(e.target.value);
                }}
              >
                <option value="">All Statuses</option>
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </Form.Select>
            </div>

            <Form.Select
              className="unit-page-size"
              aria-label="Rows per page"
              value={pageSize}
              onChange={(e) => {
                setCurrentPage(1);
                setPageSize(Number(e.target.value));
              }}
            >
              <option value={10}>10 rows</option>
              <option value={20}>20 rows</option>
              <option value={50}>50 rows</option>
            </Form.Select>
          </div>
        </div>

        <div className="unit-table-wrapper">
          {loading ? (
            <div className="unit-loader">
              <Spinner animation="border" />
              <p>Loading designations...</p>
            </div>
          ) : (
            <Table responsive className="unit-table">
              <thead>
                <tr>
                  <th style={{ width: 70 }}>S.NO.</th>
                  <th className="sortable" onClick={() => handleSort("name")}>
                    Name {sortIcon("name")}
                  </th>
                  <th className="sortable" onClick={() => handleSort("code")}>
                    Code {sortIcon("code")}
                  </th>
                  <th>Department</th>
                  <th className="sortable" onClick={() => handleSort("level")}>
                    Level {sortIcon("level")}
                  </th>
                  <th>Managerial</th>
                  <th className="sortable" onClick={() => handleSort("is_active")}>
                    Status {sortIcon("is_active")}
                  </th>
                  <th className="text-end">Actions</th>
                </tr>
              </thead>

              <tbody>
                {designations.length > 0 ? (
                  designations.map((des, index) => (
                    <tr key={des.id}>
                      <td>{getSerialNumber(index, currentPage, pageSize)}</td>
                      <td>
                        <div className="unit-name-box">
                          <div className="unit-letter">
                            {des.name?.charAt(0)?.toUpperCase() || "D"}
                          </div>

                          <div className="designation-name-copy">
                            <strong title={des.name}>{des.name}</strong>
                            <small>Designation ID: {des.id}</small>
                          </div>
                        </div>
                      </td>
                      <td>
                        {des.code ? (
                          <span className="designation-code-chip">
                            <i className="fa-solid fa-code" aria-hidden="true"></i>
                            {des.code}
                          </span>
                        ) : (
                          <span className="desig-muted">—</span>
                        )}
                      </td>
                      <td>
                        {des.department_name || departmentMap[String(des.department_id)] ? (
                          <Badge className="unit-status designation-department-badge">
                            <i className="fa-solid fa-building me-1" aria-hidden="true"></i>
                            {des.department_name || departmentMap[String(des.department_id)]}
                          </Badge>
                        ) : (
                          <span className="desig-muted">Department-agnostic</span>
                        )}
                      </td>
                      <td>
                        {des.level ?? des.level === 0 ? (
                          <span className="designation-level-chip">
                            <i className="fa-solid fa-layer-group" aria-hidden="true"></i>
                            Level {des.level}
                          </span>
                        ) : (
                          <span className="desig-muted">—</span>
                        )}
                      </td>
                      <td>
                        {des.is_managerial ? (
                          <Badge className="unit-status designation-managerial-badge">
                            <i className="fa-solid fa-user-tie me-1" aria-hidden="true"></i>
                            Managerial
                          </Badge>
                        ) : (
                          <span className="designation-nonmanagerial-chip">
                            <i className="fa-regular fa-user" aria-hidden="true"></i>
                            Individual
                          </span>
                        )}
                      </td>
                      <td>
                        <Badge
                          className={`unit-status ${
                            des.is_active
                              ? "designation-status-active"
                              : "designation-status-inactive"
                          }`}
                        >
                          <i
                            className={
                              des.is_active
                                ? "fa-solid fa-circle-check me-1"
                                : "fa-solid fa-circle-pause me-1"
                            }
                            aria-hidden="true"
                          ></i>
                          {des.is_active ? "Active" : "Inactive"}
                        </Badge>
                      </td>
                      <td>
                        <div className="unit-actions">
                          <Can moduleKey="designations" actionKey="edit">
                            <Button
                              className="unit-icon-btn unit-edit"
                              title="Edit"
                              aria-label="Edit designation"
                              onClick={() => openEdit(des)}
                            >
                              <i className="fa-solid fa-pen" aria-hidden="true"></i>
                            </Button>
                          </Can>

                          {(can("designations", "activate") || can("designations", "deactivate")) && (
                            <Button
                              className={`unit-icon-btn desig-toggle ${
                                des.is_active
                                  ? "designation-toggle-off"
                                  : "designation-toggle-on"
                              }`}
                              title={des.is_active ? "Deactivate" : "Activate"}
                              aria-label={des.is_active ? "Deactivate designation" : "Activate designation"}
                              onClick={() => toggleStatus(des)}
                            >
                              <i className={`fa-solid ${des.is_active ? "fa-pause" : "fa-play"}`} aria-hidden="true"></i>
                            </Button>
                          )}

                          <Can moduleKey="designations" actionKey="delete">
                            <Button
                              className="unit-icon-btn unit-delete"
                              title="Delete"
                              aria-label="Delete designation"
                              onClick={() => openDeleteModal(des)}
                            >
                              <i className="fa-solid fa-trash" aria-hidden="true"></i>
                            </Button>
                          </Can>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8">
                      <div className="unit-empty">
                        <div className="unit-empty-icon">
                          <i className="fa-solid fa-id-badge" aria-hidden="true"></i>
                        </div>
                        <h5>No designations found</h5>
                        <p>Try another search or add a new designation.</p>

                        <Can moduleKey="designations" actionKey="create">
                          <Button className="unit-btn unit-btn-primary" onClick={openAdd}>
                            <i className="fa-solid fa-plus" aria-hidden="true"></i>
                            Add Designation
                          </Button>
                        </Can>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
        </div>

        <div className="unit-footer">
          <div className="unit-count-text">
            Showing <strong>{designations.length}</strong> of <strong>{total}</strong> designations
          </div>

          {totalPages > 1 && (
            <Pagination className="unit-pagination">
              <Pagination.Prev
                disabled={currentPage === 1}
                onClick={() => setCurrentPage((p) => p - 1)}
              />
              {compactPageItems([...Array(totalPages)].map((_, i) => (
                <Pagination.Item
                  key={i + 1}
                  active={i + 1 === currentPage}
                  onClick={() => setCurrentPage(i + 1)}
                >
                  {i + 1}
                </Pagination.Item>
              )), currentPage)}
              <Pagination.Next
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage((p) => p + 1)}
              />
            </Pagination>
          )}
        </div>
      </div>

      <Modal
        show={showModal}
        onHide={closeModal}
        centered
        className="unit-modal"
        dialogClassName="designation-admin-modal designation-admin-modal-lg"
        backdropClassName="designation-admin-backdrop"
      >
        <Modal.Header closeButton closeLabel="Close">
          <div className="designation-modal-heading">
            <div className="designation-modal-icon">
              <i
                className={
                  editId
                    ? "fa-solid fa-pen-to-square"
                    : "fa-solid fa-id-badge"
                }
                aria-hidden="true"
              ></i>
            </div>

            <div>
              <small>Designation Setup</small>
              <Modal.Title>{editId ? "Edit Designation" : "Add New Designation"}</Modal.Title>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="row g-3">
            <div className="col-md-6 admin-form-col">
              <Form.Label htmlFor="designation-name">Name</Form.Label>
              <div className="admin-icon-field">
                <i className="fa-solid fa-id-badge" aria-hidden="true"></i>
                <Form.Control
                  id="designation-name"
                  placeholder="e.g. Senior Software Engineer"
                  value={form.name}
                  onChange={(e) => handleChange("name", e.target.value)}
                />
              </div>
            </div>

            <div className="col-md-6 admin-form-col">
              <Form.Label htmlFor="designation-code">Code (optional — derived from name if blank)</Form.Label>
              <div className="admin-icon-field">
                <i className="fa-solid fa-code" aria-hidden="true"></i>
                <Form.Control
                  id="designation-code"
                  placeholder="e.g. SR_SW_ENGINEER"
                  value={form.code}
                  onChange={(e) => handleChange("code", e.target.value)}
                />
              </div>
            </div>

            <div className="col-md-12 admin-form-col">
              <Form.Label htmlFor="designation-description">Description</Form.Label>
              <Form.Control
                id="designation-description"
                as="textarea"
                rows={2}
                value={form.description}
                onChange={(e) => handleChange("description", e.target.value)}
              />
            </div>

            <div className="col-md-4 admin-form-col">
              <Form.Label htmlFor="designation-department">Department (optional)</Form.Label>
              <Form.Select
                id="designation-department"
                value={form.department_id}
                onChange={(e) => handleChange("department_id", e.target.value)}
              >
                <option value="">Department-agnostic</option>
                {departments.map((d) => (
                  <option key={d.id} value={d.id}>
                    {d.name}
                  </option>
                ))}
              </Form.Select>
            </div>

            <div className="col-md-4 admin-form-col">
              <Form.Label htmlFor="designation-level">Level (hierarchy display only)</Form.Label>
              <Form.Control
                id="designation-level"
                type="number"
                min="0"
                placeholder="e.g. 3"
                value={form.level}
                onChange={(e) => handleChange("level", e.target.value)}
              />
            </div>

            <div className="col-md-4 admin-form-col">
              <Form.Label htmlFor="designation-display-order">Display Order</Form.Label>
              <Form.Control
                id="designation-display-order"
                type="number"
                value={form.display_order}
                onChange={(e) => handleChange("display_order", e.target.value)}
              />
            </div>

            <div className="col-md-12">
              <Form.Check
                id="designation-is-managerial"
                className="designation-managerial-check"
                type="checkbox"
                label="This designation is managerial (descriptive only — grants no permission)"
                checked={form.is_managerial}
                onChange={(e) => handleChange("is_managerial", e.target.checked)}
              />
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button className="unit-btn unit-btn-light" onClick={closeModal}>
            <i className="fa-solid fa-arrow-left" aria-hidden="true"></i>
            Cancel
          </Button>

          <Button
            className="unit-btn unit-btn-primary"
            onClick={handleSave}
            disabled={saving}
          >
            {saving ? (
              <>
                <Spinner animation="border" size="sm" />
                Saving...
              </>
            ) : (
              <>
                <i className="fa-solid fa-floppy-disk" aria-hidden="true"></i>
                {editId ? "Update Designation" : "Create Designation"}
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showDeleteModal}
        onHide={closeDeleteModal}
        centered
        className="unit-modal"
        dialogClassName="designation-admin-modal designation-admin-modal-sm designation-admin-modal-danger"
        backdropClassName="designation-admin-backdrop"
      >
        <Modal.Header closeButton closeLabel="Close">
          <div className="designation-modal-heading">
            <div className="designation-modal-icon designation-modal-icon-danger">
              <i className="fa-solid fa-trash" aria-hidden="true"></i>
            </div>

            <div>
              <small>Delete Action</small>
              <Modal.Title>Delete Designation?</Modal.Title>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="designation-modal-danger-visual" aria-hidden="true">
            <i className="fa-solid fa-id-badge"></i>
          </div>
          <p className="unit-delete-text text-center">
            Are you sure you want to delete "{deleteTarget?.name}"? This action cannot be undone.
            If active users still reference it, deletion will be blocked.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button className="unit-btn unit-btn-light" onClick={closeDeleteModal}>
            <i className="fa-solid fa-arrow-left" aria-hidden="true"></i>
            Cancel
          </Button>

          <Button className="unit-btn unit-btn-danger" onClick={confirmDelete}>
            <i className="fa-solid fa-trash" aria-hidden="true"></i>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
